import { useState, useEffect, FC } from "react";
import { ProfileResponse, VehicleResponse } from "../api/ApiClient";

export const ProfileComplete: FC<{
  profile: ProfileResponse;
  vehicles: VehicleResponse[];
}> = ({ profile, vehicles }) => {
  const [tasks, setTasks] = useState<string[]>([]);

  useEffect(() => {
    var t = [];

    if (vehicles && vehicles.length === 0) {
      t.push("Add a vehicle");
    }

    if (
      profile.firstName === null ||
      profile.firstName?.trim() === "" ||
      profile.lastName === null ||
      profile.lastName?.trim() === "" ||
      profile.mobile === null ||
      profile.mobile?.trim() === ""      
    ) {
      t.push("Complete your profile (see Details tab)");
    }

    if(profile.notifyByEmail === false && profile.notifyBySms === false)
    {
      t.push("Set a notification method (see Details > Preferences tab)");
    }

    if (
      profile.agreeTermsConditions === null ||
      profile.agreeTermsConditions === false
    ) {
      t.push("Agree to Terms and Conditions (see Details > Personal Info tab)");
    }

    if (profile.stripeMetadata === null) {
      t.push("Add a payment method (see Details > Payment Methods tab)");
    }

    // Note: hasExpiredPayment not available in ProfileResponse
    // This check would need to be added to the API response if needed

    setTasks([...t]);
  }, [profile, vehicles]);

  return (
    <>
      {tasks.length > 0 && (
        <div className="container">
          <div className="alert alert-danger">
            <div>Please do the following to complete your profile</div>
            <ul className="mt-3">
              {tasks.map((task, index) => (
                <li key={"task" + index}>{task}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};
